import { useEffect, useRef, useState } from "react";
import AboutUs from './AboutUs';
import Features from './Features';
import Footer from './Footer';
import Header from './Header';
import Heromui from './Heromui';
import MentorSection from './MentorSection';
import Packages from './Packages';
import TestSeriesSection from './TestSeriesSection';
const LandingHome = () => {

    const [open, setOpen] = useState(false);

    const aboutRef = useRef(null);
    const featureRef = useRef(null);
    const mentorRef = useRef(null);
    const testRef = useRef(null);
    const packagesRef = useRef(null);

    const shownOnce = useRef({
        about: false,
        features: false,
        mentor: false,
        test: false,
    });

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const id = entry.target.getAttribute("data-section");

                        if (!shownOnce.current[id]) {
                            shownOnce.current[id] = true;
                            setOpen(true); // open modal on section reveal
                        }
                    }
                });
            },
            { threshold: 0.3 } // 30% visible triggers it
        );

        // if (testRef.current) observer.observe(testRef.current);
        // if (aboutRef.current) observer.observe(aboutRef.current);
        // if (featureRef.current) observer.observe(featureRef.current);
        // if (mentorRef.current) observer.observe(mentorRef.current);

        return () => observer.disconnect();
    }, []);

    const handleClose = () => setOpen(false);

    const scrollToPackages = () => {
        if (packagesRef.current) {
            packagesRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };
    return (
        <div>
            <Header />
            <Heromui setShowForm={scrollToPackages} />
            <div ref={packagesRef} data-section="packages">
                <Packages />
            </div>
            <div ref={testRef} data-section="test">
                <TestSeriesSection setShowForm={scrollToPackages} />
            </div>

            <div ref={mentorRef} data-section="mentor">
                <MentorSection setShowForm={scrollToPackages} />
                {/* () => setOpen(true)} /> */}
            </div>

            <div ref={featureRef} data-section="features">
                <Features setShowForm={scrollToPackages} />
            </div>

            <div ref={aboutRef} data-section="about">
                <AboutUs setShowForm={scrollToPackages} />
            </div>

            <Footer />
            {/* Popup Modal */}
            {/* <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "70%", md: "50%" }, // responsive width
                        maxHeight: "90vh",
                        overflowY: "auto",
                        bgcolor: "white",
                        borderRadius: 2,
                        p: 3,
                        boxShadow: 24,
                    }}
                >
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "grey.600",
                            "&:hover": { color: "black" },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <LeadGenerationForm handleCloseForm={() => handleClose()} />
                </Box>
            </Modal> */}
        </div>
    );
}

export default LandingHome;
